import { Navigate, useLocation } from "react-router-dom";
import { RoutesE } from "./routesData";

/**
 * `/report/videoadreport` was the single URL of the GlobalAdmin report page until spec 46 gave each
 * report its own route. Old bookmarks — and tabs opened from the General report's "navigate to
 * client report" action before the deploy — still arrive here.
 *
 * `?clientId=` used to force the Client report, so it goes to `/report/client` with the query string
 * kept verbatim (`month` rides along); everything else goes to the General report.
 *
 * `replace`, as in RedirectToLogin: Back must not return to the old URL and bounce again.
 */
const LegacyVideoReportRedirect = () => {
  const { search } = useLocation();
  const hasClientId = new URLSearchParams(search).has("clientId");

  return (
    <Navigate
      to={
        hasClientId
          ? `${RoutesE.REPORT_CLIENT}${search}`
          : RoutesE.REPORT_GENERAL
      }
      replace
    />
  );
};

export default LegacyVideoReportRedirect;
